import {Component, computed, inject, OnInit, Signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {SelectButton} from 'primeng/selectbutton';
import {PrimeTemplate} from 'primeng/api';
import {CreateTaStepType} from '../../../util/app.types';
import {TableModule} from 'primeng/table';
import {TaAppStore} from '../../../state/clcta-store';
import {TaSubmissionDatasource} from '../../../datasources/ta-submission.datasource';
import {FullTaDetails} from '../../../api';
import {ManageTaContainerComponent} from "../../components/manage-ta/manage-ta-container/manage-ta-container.component";
import {ViewTaComponent} from '../../components/view-ta/view-ta.component';
import {combineLatest} from 'rxjs';
import {ActivatedRoute, UrlSegment} from '@angular/router';
import {PermissionService} from '../../../services/permission.service';

@Component({
  selector: 'clc-manage-ta-page',
  imports: [
    FormsModule,
    SelectButton,
    PrimeTemplate,
    TableModule,
    ManageTaContainerComponent,
    ViewTaComponent,
  ],
  templateUrl: './clc-manage-ta-page.html',
  styleUrl: './clc-manage-ta-page.scss'
})
export class ClcManageTaPage implements OnInit {
  store = inject(TaAppStore);
  route = inject(ActivatedRoute);
  taSubmissionDatasource = inject(TaSubmissionDatasource);
  permissionService = inject(PermissionService);
  taSubmission = computed<FullTaDetails | undefined>(() => this.store.taSubmission())
  taLoaded = computed<boolean>(() => !!this.store.taSubmission());

  showDetailsState = 'showDetails';
  showDetailsOptions = [
    { label: 'Show Full TA Details', value: 'showDetails', icon: 'pi pi-eye' },
    { label: 'Hide Full TA Details', value: 'hideDetails', icon: 'pi pi-eye-slash' }
  ];

  ngOnInit() {
    combineLatest([
      this.route.url,
      this.route.queryParams
    ]).subscribe(([segments, params]) => {
      const pathParts = segments.map((segment: UrlSegment) => segment.path);
      let isTa = (pathParts[0] === 'ta')
      if (isTa) {
        const submissionId: string = pathParts.length > 1 ? pathParts[1] : ''
        if (submissionId) {
          this.taSubmissionDatasource.nullLoadServerTaSubmission(submissionId);
        }
      }
    });
  }

  editDialogClosed(): void {
    this.taSubmissionDatasource.updateTaEstimateValue(this.taSubmission()!.id!)
    this.taSubmissionDatasource.updateTaPrepaidStatus(this.taSubmission()!.id!)
  }

  protected readonly CreateTaStepType = CreateTaStepType;
}
